<template>
  <b-card class="bg-white rounded-xl">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('affiliate-products')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Add Product</h2>
    </div>
    <b-form role="form">
      <base-input
        alternative
        class="mb-3"
        name="Title"
        placeholder="Title"
        v-model="title"
      >
      </base-input>
      <FileUploader v-show="!image" :image="image" :onSuccess="handleSuccess" />
    </b-form>
  </b-card>
</template>

<script>
import FileUploader from "./components/FileUploader.vue";
export default {
  components: {
    FileUploader,
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>

<style>
</style>